import {ApiModel} from "../../classes/api/class.api.model";
import {ApiCartItem} from "./class.model.cart.item";
import {ApiCartItems} from "./class.model.cart.items";

export class ApiCart extends ApiModel {
    constructor(properties = {})
    {
        let fillable = [
            'idx',
            'store_ids',
            'price_total_infos',
        ];

        super(fillable, properties);
    }

    static all()
    {
        return new window.Promise((resolve, reject) => {
            this.callAPI(route('api.carts.index'))
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    clear()
    {
        return new window.Promise((resolve, reject) => {
            ApiModel.callAPI(route('api.cart.clear', { cart_id: this.idx }), {}, 'DELETE')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    createItem(cart_item_data)
    {
        return new window.Promise((resolve, reject) => {
            ApiCartItem.create(this.idx, cart_item_data)
                .then(cart_item => {
                    resolve(cart_item);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    createItemQty(cart_item_data)
    {
        return new window.Promise((resolve, reject) => {
            ApiCartItem.createWithQty(this.idx, cart_item_data)
                .then(cart_item => {
                    resolve(cart_item);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    deleteItemByProductId(product_id)
    {
        return new window.Promise((resolve, reject) => {
            let endpoint = route('api.cart.items.delete.product', {
                cart_id: this.idx,
                product_id: product_id,
            });

            ApiModel.callAPI(endpoint, {}, 'DELETE')
                .then(remaining_product_items => {
                    resolve(Object.keys(remaining_product_items).length);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    deleteItemByProductIdQty(cart_item_data)
    {
        return new window.Promise((resolve, reject) => {
            let endpoint = route('api.cart.items.delete.product.qty',{
                cart_id: this.idx,
                product_id: cart_item_data.product_id,
                event_id: cart_item_data.event_id,
                quantity: cart_item_data.quantity,
            });
            ApiModel.callAPI(endpoint, {}, 'DELETE')
                .then(remaining_product_items => {
                    resolve(Object.keys(remaining_product_items).length);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    deleteItemByIdx(idx)
    {
        return new window.Promise((resolve, reject) => {
            let endpoint = route('api.cart.items.delete.idx',{
                cart_id: this.idx,
                idx: idx,
            });
            ApiModel.callAPI(endpoint, {}, 'DELETE')
                .then(remaining_product_items => {
                    resolve('ok');
                })
                .catch(error => {
                    reject(error);
                });
        });
    }


    static find(cart_id)
    {

    }

    item(item_id)
    {
        return new ApiCartItem({
            cart_id: this.idx,
            idx: item_id,
        });
    }

    items()
    {
        return new ApiCartItems(this.idx);
    }

    static load()
    {
        return new window.Promise((resolve, reject) => {
            this.callAPI(route('api.carts.current-cart'))
                .then(api_cart_data => {
                    resolve(new ApiCart(api_cart_data));
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}
